import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons";

const SidebarItem = ({ item, isClickable, count = null, className = "" }) => {
  const { t } = useTranslation();

  const iconDef =
    item.iconActive && item.isActive ? item.iconActive : item.icon;
  const icon = iconDef ? (
    <FontAwesomeIcon icon={iconDef} className="sidebar-item-icon" />
  ) : null;

  const label = (
    <span className="sidebar-item-label">
      {`${count ? `${count}. ` : ""}${t(`${item.tKey}sidebar`)}`}
    </span>
  );

  return (
    <div
      className={`p2 sidebar-item ${
        item.isActive ? "active" : ""
      } ${className}`}
    >
      {!isClickable && (
        <span className="sidebar-item-content">
          {icon}
          {label}
        </span>
      )}
      {isClickable && item.onClick ? (
        <NavLink onClick={item.onClick} className="sidebar-link">
          {icon}
          {label}
        </NavLink>
      ) : (
        isClickable &&
        item.href !== null &&
        item.href !== undefined && (
          <NavLink
            to={isClickable ? item.href : "#"}
            target={item.outsideLink ? "_blank" : "_self"}
            rel={item.outsideLink ? "noopener noreferrer" : undefined}
            className="sidebar-link"
          >
            {icon}
            {label}
            {item.outsideLink && (
              <FontAwesomeIcon
                className="sidebar-item-label ml-3"
                icon={faArrowUpRightFromSquare}
              />
            )}
          </NavLink>
        )
      )}
    </div>
  );
};

export default SidebarItem;
